<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17KTs8t/images/cover.jpg?1684213829111" alt="This image is the cover for the book The Intern Murders"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Intern Murders
      </h1>
      <p class="bookDescription body article font2">
        <p>The Intern Murders is a convoluted enigma stymieing the best of the best as they seek out the worst of the worst to find a killer or killers. After two interns are killed, the motive is simple, and the dragnet begins. After five murders, SCOTUS is in existential danger; the obvious original motives are moot; and the FBI and the nation's intelligence services feel like fools. There is vituperation between and among the blacks and whites, the Republicans and Democrats, more than a few international players, and it looks like war will break out within the hallowed chambers of the Supreme Court Justices. There is no end in sight.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carl Douglass
      </h2>
      
      <p class="authorDescription body article">Carl Douglass is retired and happy working his mind about such thorny issues as human trafficking and bouncing his ideas off his bright and common-sensical wife of 60 years. In these days of COVID, the partnership helps keep them occupied during the enforced lockdown. So, he is not just sitting around getting soft and fat in his Western home. He still enjoys his fine wife, grown-up grandchildren, and now four great-grandchildren. Only the best grandpas get promoted to great-grandpa.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Publication Consultants
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0804554c